import { Component, computed, effect, signal, TrackByFunction, untracked } from "@angular/core";
import { toObservable, toSignal } from "@angular/core/rxjs-interop";
import { BrnAlertDialogContentDirective, BrnAlertDialogModule, BrnAlertDialogTriggerDirective } from "@spartan-ng/brain/alert-dialog";
import { BrnCommandImports } from "@spartan-ng/brain/command";
import { BrnContextMenuTriggerDirective, BrnMenuBarModule, BrnMenuTriggerDirective } from "@spartan-ng/brain/menu";
import { BrnPopoverComponent, BrnPopoverContentDirective, BrnPopoverTriggerDirective } from "@spartan-ng/brain/popover";
import { BrnTableModule, PaginatorState, useBrnColumnManager } from "@spartan-ng/brain/table";
import { HlmAccordionContentComponent, HlmAccordionDirective, HlmAccordionIconDirective, HlmAccordionItemDirective, HlmAccordionModule, HlmAccordionTriggerDirective } from "@spartan-ng/ui-accordion-helm";
import { HlmAlertDescriptionDirective, HlmAlertDirective, HlmAlertIconDirective, HlmAlertModule, HlmAlertTitleDirective } from "@spartan-ng/ui-alert-helm";
import { HlmAlertDialogActionButtonDirective, HlmAlertDialogCancelButtonDirective, HlmAlertDialogComponent, HlmAlertDialogContentComponent, HlmAlertDialogDescriptionDirective, HlmAlertDialogFooterComponent, HlmAlertDialogHeaderComponent, HlmAlertDialogModule, HlmAlertDialogTitleDirective } from "@spartan-ng/ui-alertdialog-helm";
import { HlmAvatarComponent, HlmAvatarFallbackDirective, HlmAvatarImageDirective, HlmAvatarModule } from "@spartan-ng/ui-avatar-helm";
import { HlmBadgeDirective } from "@spartan-ng/ui-badge-helm";
import { HlmBreadcrumbDirective, HlmBreadcrumbEllipsisComponent, HlmBreadcrumbItemDirective, HlmBreadcrumbLinkDirective, HlmBreadcrumbListDirective, HlmBreadCrumbModule, HlmBreadcrumbPageDirective, HlmBreadcrumbSeparatorComponent } from "@spartan-ng/ui-breadcrumb-helm";
import { HlmButtonDirective, HlmButtonModule } from "@spartan-ng/ui-button-helm";
import { HlmCalendarComponent } from "@spartan-ng/ui-calendar-helm";
import { HlmCardContentDirective, HlmCardDescriptionDirective, HlmCardDirective, HlmCardFooterDirective, HlmCardHeaderDirective, HlmCardModule, HlmCardTitleDirective } from "@spartan-ng/ui-card-helm";
import { HlmCarouselComponent, HlmCarouselContentComponent, HlmCarouselItemComponent, HlmCarouselModule, HlmCarouselNextComponent, HlmCarouselPreviousComponent } from "@spartan-ng/ui-carousel-helm";
import { HlmCheckboxComponent } from "@spartan-ng/ui-checkbox-helm";
import { HlmCommandImports } from "@spartan-ng/ui-command-helm";
import { HlmIconDirective } from "@spartan-ng/ui-icon-helm";
import { HlmInputDirective } from "@spartan-ng/ui-input-helm";
import { HlmLabelDirective } from "@spartan-ng/ui-label-helm";
import { HlmMenuBarModule, HlmMenuComponent, HlmMenuGroupComponent, HlmMenuItemCheckboxDirective, HlmMenuItemCheckComponent, HlmMenuItemDirective, HlmMenuItemIconDirective, HlmMenuItemRadioComponent, HlmMenuItemRadioDirective, HlmMenuItemSubIndicatorComponent, HlmMenuLabelComponent, HlmMenuModule, HlmMenuSeparatorComponent, HlmMenuShortcutComponent, HlmSubMenuComponent } from "@spartan-ng/ui-menu-helm";
import { HlmPopoverContentDirective } from "@spartan-ng/ui-popover-helm";
import { debounceTime, map } from "rxjs";
import { SelectionModel } from '@angular/cdk/collections';
import { FormsModule } from "@angular/forms";
import { HlmTableModule } from "@spartan-ng/ui-table-helm";
import { DecimalPipe, TitleCasePipe } from "@angular/common";
import { BrnSelectModule } from "@spartan-ng/brain/select";
import { HlmSelectModule } from "@spartan-ng/ui-select-helm";
import { HlmDatePickerComponent } from "@spartan-ng/ui-datepicker-helm";
import { HlmFormFieldModule } from "@spartan-ng/ui-formfield-helm";
import { HlmHoverCardModule } from "@spartan-ng/ui-hovercard-helm";
import { BrnHoverCardModule } from '@spartan-ng/brain/hover-card';
import { HlmInputOtpDirective, HlmInputOtpModule } from "@spartan-ng/ui-inputotp-helm";
import { BrnInputOtpModule } from "@spartan-ng/brain/input-otp";
import { HlmDialogFooterComponent, HlmDialogModule } from "@spartan-ng/ui-dialog-helm";
import { HlmPaginationModule } from "@spartan-ng/ui-pagination-helm";
import { HlmSheetModule } from "@spartan-ng/ui-sheet-helm";
import { BrnSheetModule } from "@spartan-ng/brain/sheet";
import { HlmSliderComponent } from "@spartan-ng/ui-slider-helm";
import { toast } from "ngx-sonner";
import { HlmToasterComponent } from "@spartan-ng/ui-sonner-helm";
import { HlmSwitchComponent } from "@spartan-ng/ui-switch-helm";

export type Payment = {
  id: string;
  amount: number;
  status: 'pending' | 'processing' | 'success' | 'failed';
  email: string;
};

const PAYMENT_DATA: Payment[] = [
  {
    id: 'm5gr84i9',
    amount: 316,
    status: 'success',
    email: 'ken99@yahoo.com',
  },
  {
    id: '3u1reuv4',
    amount: 242,
    status: 'success',
    email: 'Abe45@gmail.com',
  },
  {
    id: 'derv1ws0',
    amount: 837,
    status: 'processing',
    email: 'Monserrat44@gmail.com',
  },
  {
    id: '5kma53ae',
    amount: 874,
    status: 'success',
    email: 'Silas22@gmail.com',
  },
  {
    id: 'bhqecj4p',
    amount: 721,
    status: 'failed',
    email: 'carmella@hotmail.com',
  },
  {
    id: 'p0r8sd2f',
    amount: 123,
    status: 'failed',
    email: 'john.doe@example.com',
  },
  {
    id: '8uyv3n1x',
    amount: 589,
    status: 'processing',
    email: 'emma.smith@gmail.com',
  },
  {
    id: '2zqo6ptr',
    amount: 456,
    status: 'success',
    email: 'jackson78@hotmail.com',
  },
  {
    id: 'l7we9a3m',
    amount: 632,
    status: 'success',
    email: 'grace_22@yahoo.com',
  },
  {
    id: 'o9p2v3qk',
    amount: 987,
    status: 'failed',
    email: 'robert.adams@gmail.com',
  },
  {
    id: 'q1o8r7mz',
    amount: 321,
    status: 'processing',
    email: 'alexander34@gmail.com',
  },
  {
    id: 'i5n3s0tv',
    amount: 555,
    status: 'failed',
    email: 'olivia_morris@hotmail.com',
  },
  {
    id: '3xr7s2nl',
    amount: 789,
    status: 'success',
    email: 'michael_cole@yahoo.com',
  },
  {
    id: 'u9v2p1qy',
    amount: 234,
    status: 'success',
    email: 'lily.jones@gmail.com',
  },
  {
    id: 'b4q0e1cp',
    amount: 876,
    status: 'failed',
    email: 'ryan_14@hotmail.com',
  },
  {
    id: 's1z8m7op',
    amount: 456,
    status: 'success',
    email: 'sophia.green@gmail.com',
  },
  {
    id: 'n5a3v0lt',
    amount: 987,
    status: 'failed',
    email: 'david.miller@yahoo.com',
  },
  {
    id: '2qr7v9sm',
    amount: 654,
    status: 'processing',
    email: 'emma_jones@hotmail.com',
  },
  {
    id: 'y9b2h8qq',
    amount: 789,
    status: 'success',
    email: 'jacob_89@gmail.com',
  },
  {
    id: 'c4a0r1xp',
    amount: 123,
    status: 'failed',
    email: 'samantha.richards@yahoo.com',
  },
];

@Component({
  selector: 'page-test',
  templateUrl: './test.page.html',
  imports: [
    HlmAccordionModule,
    HlmIconDirective,
    HlmAlertModule,
    HlmAlertDialogModule,
    HlmDialogModule,
    BrnAlertDialogModule,
    HlmButtonDirective,
    HlmAvatarModule,
    HlmBadgeDirective,
    HlmBreadCrumbModule,
    BrnMenuTriggerDirective,
    HlmMenuModule,
    HlmCalendarComponent,
    BrnCommandImports,
    HlmCommandImports,
    HlmCardModule,
    HlmLabelDirective,
    HlmInputDirective,
    HlmCardFooterDirective,
    HlmCarouselModule,
    HlmCheckboxComponent,
    HlmButtonDirective,
    BrnPopoverComponent,
    BrnPopoverTriggerDirective,
    HlmPopoverContentDirective,
    BrnPopoverContentDirective,
    BrnMenuTriggerDirective,
    BrnContextMenuTriggerDirective,
    FormsModule,
    HlmMenuModule,
    BrnTableModule,
    HlmTableModule,
    HlmButtonModule,
    DecimalPipe,
    TitleCasePipe,
    BrnSelectModule,
    HlmSelectModule,
    HlmDatePickerComponent,
    HlmFormFieldModule,
    BrnHoverCardModule, 
    HlmHoverCardModule, 
    HlmAvatarModule,
    HlmInputOtpDirective,
    HlmInputOtpModule,
    BrnInputOtpModule,
    HlmMenuBarModule,
    BrnMenuBarModule,
    HlmPaginationModule,
    HlmSheetModule,
    BrnSheetModule,
    HlmSliderComponent,
    HlmToasterComponent,
    HlmSwitchComponent
  ],
})
export class TestPage {
  
  protected readonly _rawFilterInput = signal('');
  protected readonly _emailFilter = signal('');
  private readonly _debouncedFilter = toSignal(toObservable(this._rawFilterInput).pipe(debounceTime(300)));
  
  private readonly _displayedIndices = signal({ start: 0, end: 0 });
  protected readonly _availablePageSizes = [5, 10, 20, 10000];
  protected readonly _pageSize = signal(this._availablePageSizes[0]);
  
  private readonly _selectionModel = new SelectionModel<Payment>(true);
  protected readonly _isPaymentSelected = (payment: Payment) => this._selectionModel.isSelected(payment);
  protected readonly _selected = toSignal(this._selectionModel.changed.pipe(map((change) => change.source.selected)), {
    initialValue: [],
  });
  
  protected readonly _brnColumnManager = useBrnColumnManager({
    status: { visible: true, label: 'Status' },
    email: { visible: true, label: 'Email' },
    amount: { visible: true, label: 'Amount ($)' },
  });
  protected readonly _allDisplayedColumns = computed(() => [
    'select',
    ...this._brnColumnManager.displayedColumns(),
    'actions',
  ]);
  
  private readonly _payments = signal(PAYMENT_DATA);
  private readonly _filteredPayments = computed(() => {
    const emailFilter = this._emailFilter()?.trim()?.toLowerCase();
    if (emailFilter && emailFilter.length > 0) {
      return this._payments().filter((u) => u.email.toLowerCase().includes(emailFilter));
    }
    return this._payments();
  });
  private readonly _emailSort = signal<'ASC' | 'DESC' | null>(null);
  protected readonly _filteredSortedPaginatedPayments = computed(() => {
    const sort = this._emailSort();
    const start = this._displayedIndices().start;
    const end = this._displayedIndices().end + 1;
    const payments = this._filteredPayments();
    if (!sort) {
      return payments.slice(start, end);
    }
    return [...payments]
    .sort((p1, p2) => (sort === 'ASC' ? 1 : -1) * p1.email.localeCompare(p2.email))
    .slice(start, end);
  });
  protected readonly _allFilteredPaginatedPaymentsSelected = computed(() =>
    this._filteredSortedPaginatedPayments().every((payment: any) => this._selected().includes(payment)),
  );
  protected readonly _checkboxState = computed(() => {
    const noneSelected = this._selected().length === 0;
    const allSelectedOrIndeterminate = this._allFilteredPaginatedPaymentsSelected() ? true : 'indeterminate';
    return noneSelected ? false : allSelectedOrIndeterminate;
  });

  protected readonly _trackBy: TrackByFunction<Payment> = (_: number, p: Payment) => p.id;
  protected readonly _totalElements = computed(() => this._filteredPayments().length);
  protected readonly _onStateChange = ({ startIndex, endIndex }: PaginatorState) =>
    this._displayedIndices.set({ start: startIndex, end: endIndex });

  constructor() {
    // needed to sync the debounced filter to the name filter, but being able to override the
    // filter when loading new users without debounce
    effect(() => {
      const debouncedFilter = this._debouncedFilter();
      untracked(() => this._emailFilter.set(debouncedFilter ?? ''));
    });
  }

  showToast() {
    toast('Event has been created', {
      description: 'Sunday, December 03, 2024 at 9:00 AM',
      action: {
        label: 'Undo',
        onClick: () => console.log('Undo'),
      }
    })
  }

  protected togglePayment(payment: Payment) {
    this._selectionModel.toggle(payment);
  }

  protected handleHeaderCheckboxChange() {
    const previousCbState = this._checkboxState();
    if (previousCbState === 'indeterminate' || !previousCbState) {
      this._selectionModel.select(...this._filteredSortedPaginatedPayments());
    } else {
      this._selectionModel.deselect(...this._filteredSortedPaginatedPayments());
    }
  }

  protected handleEmailSortChange() {
    const sort = this._emailSort();
    if (sort === 'ASC') {
      this._emailSort.set('DESC');
    } else if (sort === 'DESC') {
      this._emailSort.set(null);
    } else {
      this._emailSort.set('ASC');
    }
  }

}

